<template>
  <div>
    <CollectionView :endpoint="utilities.path('communities/@/modules/allowlist/entries', communityId)" v-model:reload="reload">>+
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="mb-0">{{ translate("entries") }}</h4>
          <ButtonView type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("target") }}</div>
                <div class="table-header-cell">{{ translate("creator") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <PlayerView :player="item.player"/>
                  </div>
                  <div class="table-column">
                    <UserView :user="item.creator"/>
                  </div>
                  <div class="table-column">
                    {{ utilities.formatDatetime(item.createdAt) }}
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <TargetedModalHttpFormView :endpoint="utilities.path('modules/allowlist/entries/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalHttpFormView v-model:active="creating" :endpoint="utilities.path('communities/@/modules/allowlist/entries', communityId)" method="post" @success="reload = true">
      <template v-slot:form="{ content, errors, submit, loading }">
        <PlayerSelectInput :endpoint="utilities.path('communities/@/modules/allowlist/entries/addable', communityId)" :title="translate('player')" :errors="errors.playerId" required v-model:value="content.playerId"/>
        <div class="d-flex align-items-center g-4 mt-4">
          <ButtonView type="normal" color="primary" class="w-100" @click="submit">
            {{ translate("save") }}
          </ButtonView>
          <ButtonView type="normal" color="secondary" class="w-100" @click="creating = false">
            {{ translate("cancel") }}
          </ButtonView>
        </div>
        <SpinnerView :active="loading" color="primary"/>
      </template>
    </ModalHttpFormView>
  </div>
</template>

<script setup>
import {ButtonView, CollectionView, SpinnerView, utilities, TargetedModalHttpFormView, ModalHttpFormView} from "@/niftybit";
import PlayerView from "@/components/other/PlayerView.vue";
import PlayerSelectInput from "@/systems/modules/players/PlayerSelectInput.vue";
import {ref} from "vue";
import UserView from "@/components/other/UserView.vue";

defineProps({
  communityId: String
});

const reload = ref(false);
const creating = ref(false);

</script>

<style scoped>

</style>